import handleCRUD from 'Helper/API/handleCRUD'

function patientDisplayReducer(state = {}, action = {}) {
  let lastPatientConfigs = []
  let injectionGraphWindow
  let injectionGraphCharts
  let newDataStandardInjection
  let newDataActivateVials
  let newData
  let lastShared
  const lastStandardInjectionWindow =
    state.standardInjectionWindow != null
      ? { ...state.standardInjectionWindow }
      : null
  const lastActivateVialsWindow =
    state.activateVialsWindow != null ? { ...state.activateVialsWindow } : null
  const lastInjectionGraphWindow =
    state.injectionGraphWindow != null
      ? { ...state.injectionGraphWindow }
      : null
  const lastPatientDetailsWindow =
    state.patientDetailsWindow != null
      ? { ...state.patientDetailsWindow }
      : null
  const lastQuestionnaireWindow =
    state.questionnaireWindow != null ? { ...state.questionnaireWindow } : null
  const lastInjectionWindow =
    state.injectionWindow != null ? { ...state.injectionWindow } : null
  const lastInjAdjustWindow =
    state.injAdjustWindow != null ? { ...state.injAdjustWindow } : null
  const lastPatientDetails =
    state.patientDetails != null ? { ...state.patientDetails } : null

  switch (action.type) {
    case 'SET_PATIENT_DISPLAY_RX':
      lastShared = state.shared ? state.shared : {}
      return {
        ...state,
        shared: { ...lastShared, prescriptionId: action.prescriptionId, prescriptionNum: action.prescriptionNum }
      }
    case 'CLEAR_VIALSLIST_WIDGET':
      return {
        ...state,
        vialsWindow: null
      }
    case 'INIT_VIALSLIST_WIDGET':
      return {
        ...state,
        vialsWindow: {}
      }
    case 'CLEAR_ATTACHMENTSLIST_WIDGET':
      return {
        ...state,
        attachmentsWindow: null
      }
    case 'INIT_ATTACHMENTSLIST_WIDGET':
      return {
        ...state, 
        attachmentsWindow: {}
      }
      case 'CLEAR_VIALTESTSCORING_WIDGET':
      return {
        ...state,
        vialTestScoringWindow: null
      }
    case 'INIT_VIALTESTSCORING_WIDGET':
      return {
        ...state,
        vialTestScoringWindow: {}
      }
    case 'CLEAR_SKINTESTANTIGENS_WIDGET':
      return {
        ...state,
        skinTestAntigensWindow: null
      }
    case 'INIT_SKINTESTANTIGENS_WIDGET':
      return {
        ...state,
        skinTestAntigensWindow: {}
      }
    case 'CLEAR_SKINTESTHISTORY_WIDGET':
      return {
        ...state,
        skinTestHistoryWindow: null
      }
    case 'INIT_SKINTESTHISTORY_WIDGET':
      return {
        ...state,
        skinTestHistoryWindow: {}
      }
    case 'CLEAR_SKINTESTDETAIL_WIDGET':
      return {
        ...state,
        skinTestDetailWindow: null
      }
    case 'INIT_SKINTESTDETAIL_WIDGET':
      return {
        ...state,
        skinTestDetailWindow: {}
      }
    case 'CLEAR_SKINTESTLIST_WIDGET':
      return {
        ...state,
        skinTestListWindow: null
      }
    case 'INIT_SKINTESTLIST_WIDGET':
      return {
        ...state,
        skinTestListWindow: {}
      }
    case 'CLEAR_VIALTESTLIST_WIDGET':
      return {
        ...state,
        vialTestListWindow: null
      }
    case 'INIT_VIALTESTLIST_WIDGET':
      return {
        ...state,
        vialTestListWindow: {}
      }
    case 'CLEAR_REPORTHISTORY_WIDGET':
      return {
        ...state,
        reportHistoryWindow: null
      }
    case 'INIT_REPORTHISTORY_WIDGET':
      return {
        ...state,
        reportHistoryWindow: {}
      }
    case 'CLEAR_QUESTIONNAIRE_REVIEW_WIDGET':
      return {
        ...state,
        questionnaireReviewWindow: null
      }
    case 'INIT_QUESTIONNAIRE_REVIEW_WIDGET':
      return {
        ...state,
        questionnaireReviewWindow: {}
      }
    case 'CLEAR_QUESTIONNAIRE_HISTORY_WIDGET':
      return {
        ...state,
        questionnaireHistoryWindow: null
      }
    case 'INIT_QUESTIONNAIRE_HISTORY_WIDGET':
      return {
        ...state,
        questionnaireHistoryWindow: {}
      }
    case 'CLEAR_DIRECT_MESSAGE_WINDOW':
      return {
        ...state,
        directMessageWindow: null
      }
    case 'INIT_DIRECT_MESSAGE_WINDOW':
      return {
        ...state,
        directMessageWindow: {}
      }
    case 'CLEAR_VIAL_MIXING_WIDGET':
      return {
        ...state,
        vialMixingWindow: null
      }
    case 'INIT_VIAL_MIXING_WIDGET':
      return {
        ...state,
        vialMixingWindow: state.vialMixingWindow || {}
      }
    case 'CLEAR_ORDER_ENTRY_WIDGET':
      return {
        ...state,
        orderEntryWindow: null
      }
    case 'INIT_ORDER_ENTRY_WIDGET':
      return {
        ...state,
        orderEntryWindow: {}
      }
    case 'CLEAR_DEMOGRAPHICS_WIDGET':
      return {
        ...state,
        immunotherapySummaryWindow: null
      }
    case 'INIT_DEMOGRAPHICS_WIDGET':
      return {
        ...state,
        immunotherapySummaryWindow: {}
      }
    case 'CLEAR_ACTIVATE_VIALS_WIDGET':
      return {
        ...state,
        activateVialsWindow: null
      }
    case 'INIT_ACTIVATE_VIALS_WIDGET':
      return {
        ...state,
        activateVialsWindow: {}
      }
    case 'CLEAR_QUESTIONNAIRE_WIDGET':
      return {
        ...state,
        questionnaireWindow: null
      }
    case 'INIT_QUESTIONNAIRE_WIDGET':
      return {
        ...state,
        questionnaireWindow: {}
      }
    case 'CLEAR_TRACKING_WIDGET':
      return {
        ...state,
        trackingWindow: null
      }
    case 'INIT_TRACKING_WIDGET':
      return {
        ...state,
        trackingWindow: {}
      }
    case 'CLEAR_PATIENT_DETAILS_WIDGET':
      return {
        ...state,
        patientDetailsWindow: null
      }
    case 'INIT_PATIENT_DETAILS_WIDGET':
      return {
        ...state,
        patientDetailsWindow: {}
      }
    case 'CLEAR_NON_XIS_INJECTIONS_WIDGET':
      return {
        ...state,
        nonXISInjectionsWindow: null
      }
    case 'INIT_NON_XIS_INJECTIONS_WIDGET':
      return {
        ...state,
        nonXISInjectionsWindow: {}
      }
    case 'CLEAR_PRESCRIPTION_WIDGET':
      return {
        ...state,
        prescriptionWindow: null
      }
    case 'INIT_PRESCRIPTION_WIDGET':
      return {
        ...state,
        prescriptionWindow: {}
      }
    case 'CLEAR_INJECTION_WIDGET':
      return {
        ...state,
        injectionWindow: null
      }
    case 'INIT_INJECTION_WIDGET':
      return {
        ...state,
        injectionWindow: {}
      }
    case 'CLEAR_INJECTIONLIST_WIDGET':
      return {
        ...state,
        injectionListWindow: null
      }
    case 'INIT_INJECTIONLIST_WIDGET':
      return {
        ...state,
        injectionListWindow: {}
      }
    case 'CLEAR_PURCHASE_ORDER_WIDGET':
      return {
        ...state,
        purchaseOrderWindow: null
      }
    case 'INIT_PURCHASE_ORDER_WIDGET':
      return {
        ...state,
        purchaseOrderWindow: {}
      }
    case 'CLEAR_SKINTEST_WIDGET':
      return {
        ...state,
        skintestWindow: null
      }
    case 'INIT_SKINTEST_WIDGET':
      return {
        ...state,
        skintestWindow: {}
      }
    case 'CLEAR_INJECTION_GRAPH_WIDGET':
      return {
        ...state,
        injectionGraphWindow: null
      }
    case 'INIT_INJECTION_GRAPH_WIDGET':
      return {
        ...state,
        injectionGraphWindow: {}
      }
    case 'CLEAR_INJ_ADJUST_WIDGET':
      return {
        ...state,
        injAdjustWindow: null
      }
    case 'INIT_INJ_ADJUST_WIDGET':
      return {
        ...state,
        injAdjustWindow: {}
      }
    case 'CLEAR_STANDARD_INJECTION_WIDGET':
      return {
        ...state,
        standardInjectionWindow: null
      }
    case 'INIT_STANDARD_INJECTION_WIDGET':
      return {
        ...state,
        standardInjectionWindow: {}
      }
    case 'CLEAR_PATIENT_DISPLAY':
      return { encounter: null }
    case 'CLEAR_INJECTION_DATA':
      if (
        lastStandardInjectionWindow != null &&
        lastStandardInjectionWindow.injectionsDue != null
      ) {
        delete lastStandardInjectionWindow.injectionsDue
      }
      if (
        lastInjAdjustWindow != null &&
        lastInjAdjustWindow.adjustments != null
      ) {
        delete lastInjAdjustWindow.adjustments
        delete lastInjAdjustWindow.charts
      }
      if (
        lastInjectionGraphWindow != null &&
        lastInjectionGraphWindow.charts != null
      ) {
        delete lastInjectionGraphWindow.charts
      }
      return {
        ...state,
        standardInjectionWindow: lastStandardInjectionWindow,
        injectionGraphWindow: lastInjectionGraphWindow,
        injAdjustWindow: lastInjAdjustWindow
      }
    case 'SET_PENDING_INJECTION_STATE':
      const { injectionsDue } = lastStandardInjectionWindow
      const newDue = injectionsDue.map(due => {
        const { last_injection = {} } = due
        if (last_injection.injection_id === action.injectionId) {
          return { ...due, state: action.state }
        } else {
          return { ...due }
        }
      })
      return {
        ...state,
        standardInjectionWindow: {
          ...lastStandardInjectionWindow,
          injectionsDue: newDue
        }
      }
    case 'STORE_PATIENT_TRACKING_CONFIG_READ':
    case 'STORE_PATIENT_TRACKING_CONFIG_READ_ALL':
    case 'STORE_PATIENT_TRACKING_CONFIG_SEARCH':
    case 'STORE_PATIENT_TRACKING_CONFIG_CREATE':
    case 'STORE_PATIENT_TRACKING_CONFIG_UPDATE':
    case 'STORE_PATIENT_TRACKING_CONFIG_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'tracking_config_id',
          ['trackingWindow', 'immunotherapySummaryWindow'],
          'trackingConfig'
        )
      }
    case 'STORE_PATIENT_VIAL_READ_ALL':
      newDataStandardInjection = {
        ...lastStandardInjectionWindow,
        vials: action.result
      }
      newDataActivateVials = {
        ...lastActivateVialsWindow,
        vials: [...action.result]
      }
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'vial_id',
          ['nonXISInjectionsWindow'],
          'vials'
        ),
        standardInjectionWindow:
          lastStandardInjectionWindow != null ? newDataStandardInjection : null,
        activateVialsWindow:
          lastActivateVialsWindow != null ? newDataActivateVials : null
      }
    case 'STORE_PATIENT_PRESCRIPTION_VIAL_READ':
    case 'STORE_PATIENT_PRESCRIPTION_VIAL_UPDATE':
      let newDataPatientDetails =
        lastPatientDetails != null ? { ...lastPatientDetails } : null
      let newDataStandardInjection =
        lastStandardInjectionWindow != null
          ? { ...lastStandardInjectionWindow }
          : null
      // vial update suports updating arrays of vials so the returned result could be an array of vials.
      const vials = Array.isArray(action.result)
        ? action.result
        : [action.result]
      vials.forEach(resultVial => {
      // it would be really complicated to do this right and search every place the updated vial might exist and replace it.
      // currently the only use case for this is when changing tray location in the update prescription modal. Anything else
      // that changes vials forces api reloads. As such, for now, I am only going to update the vials stored in prescriptions
      // in the patientDetails section since this is all the modal depends on. At some point it may be necessary to do more
      // in depth updates.
        let nextNewDataPatientDetails =
          newDataPatientDetails != null ? { ...newDataPatientDetails } : null
        if (
          newDataPatientDetails != null &&
          newDataPatientDetails.prescriptions != null
        ) {
          nextNewDataPatientDetails.prescriptions =
            newDataPatientDetails.prescriptions.map(rx => {
              if (rx.prescription_id === resultVial.prescription_id) {
                // this is the rx the vial belongs to
                const found = false
                const newVials = rx.vials.map(vial => {
                  if (!found) {
                    if (vial.vial_id === resultVial.vial_id) {
                      return resultVial
                    } else {
                      return vial
                    }
                  } else {
                    return vial
                  }
                })
                return { ...rx, vials: newVials } // return the rx with the updated vials
              } else {
                // the vial doesn't belong to this rx so no changes needed.
                return rx
              }
            })
          }
        // update newData for the next pass through
        newDataPatientDetails = nextNewDataPatientDetails

        // same process for standard injection window
        let nextNewDataStandardInjection =
          newDataStandardInjection != null
            ? {
                ...newDataStandardInjection
              }
            : null

      if (
          newDataStandardInjection != null &&
          newDataStandardInjection.vials != null
      ) {
        // lastStandardInjection window had data so we need to replace only the vials belonging to this rx
          nextNewDataStandardInjection.vials = [
            ...lastStandardInjectionWindow.vials.filter(vial => {
              return vial.vial_id !== resultVial.vial_id
            }),
            { ...resultVial }
        ]
              }
        // update newData for the next pass through
        newDataStandardInjection = nextNewDataStandardInjection
      })

      return {
        ...state,
        patientDetails: newDataPatientDetails,
        standardInjectionWindow: newDataStandardInjection
      }
    case 'STORE_PATIENT_PRESCRIPTION_VIAL_READ_ALL':
      // sort the vials between active and inactive
      if (
        lastActivateVialsWindow != null &&
        lastActivateVialsWindow.vials != null
      ) {
        // lastStandardInjection window had data so we need to replace only the vials belonging to this rx
        newDataActivateVials = { ...lastActivateVialsWindow }
        newDataActivateVials.vials = lastActivateVialsWindow.vials.filter(
          vial => {
            return vial.prescription_id !== action.result[0].prescription_id
          }
        )
        newDataActivateVials.vials = [
          ...newDataActivateVials.vials,
          ...action.result
        ]
      } else {
        newDataActivateVials = {
          ...lastActivateVialsWindow,
          vials: [...action.result]
        }
      }

      if (
        lastStandardInjectionWindow != null &&
        lastStandardInjectionWindow.vials != null
      ) {
        // lastStandardInjection window had data so we need to replace only the vials belonging to this rx
        newDataStandardInjection = { ...lastStandardInjectionWindow }
        newDataStandardInjection.vials =
          lastStandardInjectionWindow.vials.filter(vial => {
            return vial.prescription_id !== action.result[0].prescription_id
          })
        newDataStandardInjection.vials = [
          ...newDataStandardInjection.vials,
          ...action.result
        ]
      } else {
        newDataStandardInjection = {
          ...lastStandardInjectionWindow,
          vials: [...action.result]
        }
      }
      return {
        ...state,
        activateVialsWindow:
          lastActivateVialsWindow != null ? newDataActivateVials : null,
        standardInjectionWindow:
          lastStandardInjectionWindow != null ? newDataStandardInjection : null
      }
    case 'STORE_PATIENT_TRACKING_VALUE_READ':
    case 'STORE_PATIENT_TRACKING_VALUE_READ_ALL':
    case 'STORE_PATIENT_TRACKING_VALUE_SEARCH':
    case 'STORE_PATIENT_TRACKING_VALUE_CREATE':
    case 'STORE_PATIENT_TRACKING_VALUE_UPDATE':
    case 'STORE_PATIENT_TRACKING_VALUE_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'tracking_value_id',
          ['trackingWindow', 'immunotherapySummaryWindow'],
          'trackingData'
        )
      }
    case 'STORE_PATIENT_IMAGE':
      return {
        ...state,
        patientDetails: {
          ...lastPatientDetails,
          image: action.data.image
        }
      }
    case 'STORE_PATIENT_DEMOGRAPHICS_READ':
    case 'STORE_PATIENT_READ':
    case 'STORE_PATIENT_UPDATE':
      newData = handleCRUD(action, lastPatientDetails, 'patient_id')
      // demographics can include a prescription array so we need to
      // find the thing with a patient_id on it in that case
      newData = newData.find(item => item.patient_id > 0)
      return {
        ...state,
        patientDetailsWindow:
          lastPatientDetailsWindow != null
            ? {
                ...lastPatientDetailsWindow,
                patientDetails: {
                  ...newData
                }
              }
            : null,
        patientDetails: {
          ...lastPatientDetails,
          ...newData
        }
      }
    case 'STORE_PATIENT_IDENTIFICATION/ENROLL_READ':
    case 'STORE_PATIENT_IDENTIFICATION/ENROLL_READ_ALL':
    case 'STORE_PATIENT_IDENTIFICATION/ENROLL_SEARCH':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'identification_id',
          ['patientDetailsWindow', 'patientDetails'],
          'enrollments'
        )
      }
    case 'STORE_PATIENT_ANSWER_CREATE':
      const nextQuestionnairesDue =
        lastQuestionnaireWindow != null
          ? [...lastQuestionnaireWindow.questionnairesDue]
          : null
      if (nextQuestionnairesDue === null) {
        return { ...state }
      }
      if (Array.isArray(action.result)) {
        let questionnaireIdx
        let questionIdx
        action.result.forEach(answer => {
          // multi create
          questionnaireIdx = nextQuestionnairesDue.findIndex(questionnaire => {
            return questionnaire.questionnaire_id === answer.questionnaire_id
          })
          if (questionnaireIdx !== -1) {
            questionIdx = nextQuestionnairesDue[
              questionnaireIdx
            ].questions.findIndex(question => {
              return question.question_id === answer.question_id
            })
            if (questionIdx !== -1) {
              nextQuestionnairesDue[questionnaireIdx].questions[
                questionIdx
              ].answer = { ...answer }
            }
          }
        })
      } else {
        // single create
        const answer = action.result
        const questionnaireIdx = nextQuestionnairesDue.findIndex(
          questionnaire => {
            return questionnaire.questionnaire_id === answer.questionnaire_id
          }
        )
        if (questionnaireIdx !== -1) {
          const questionIdx = nextQuestionnairesDue[
            questionnaireIdx
          ].questions.findIndex(question => {
            return question.question_id === answer.question_id
          })
          if (questionIdx !== -1) {
            nextQuestionnairesDue[questionnaireIdx].questions[
              questionIdx
            ].answer = { ...answer }
          }
        }
      }
      return {
        ...state,
        questionnaireWindow:
          lastQuestionnaireWindow != null
            ? {
                ...lastQuestionnaireWindow,
                questionnairesDue: nextQuestionnairesDue
              }
            : null
      }
    case 'STORE_PATIENT_QUESTIONNAIRE_DUE_READ_ALL':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'questionnaire_id',
          ['questionnaireWindow', 'questionnaireReviewWindow'],
          'questionnairesDue'
        )
      }
    case 'STORE_PATIENT_QUESTIONNAIRE_READ_ALL':
    case 'STORE_PATIENT_QUESTIONNAIRE_ASSIGNMENT_CREATE':
    case 'STORE_PATIENT_QUESTIONNAIRE_ASSIGNMENT_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'questionnaire_id',
          ['patientDetailsWindow'],
          'assignedQuestionnaires'
        )
      }
    case 'STORE_PATIENT_CODE_READ_ALL':
    case 'STORE_PATIENT_CODE_ASSIGNMENT_CREATE':
    case 'STORE_PATIENT_CODE_ASSIGNMENT_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'code_id',
          ['patientDetails'],
          'codes'
        )
      }
    case 'STORE_PATIENT_INJECTION_DUE_READ':
    case 'STORE_PATIENT_INJECTION_DUE_READ_ALL':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'prescription_id',
          ['standardInjectionWindow'],
          'injectionsDue'
        )
      }
    case 'STORE_PATIENT_CONFIG_CREATE':
      lastPatientConfigs =
        lastPatientDetails.configs != null
          ? [...lastPatientDetails.configs]
          : []
      return {
        ...state,
        patientDetails: {
          ...lastPatientDetails,
          configs: [...lastPatientConfigs, { ...action.result }]
        }
      }
    case 'STORE_PATIENT_CONFIG_UPDATE':
      lastPatientConfigs =
        lastPatientDetails.configs != null
          ? [...lastPatientDetails.configs]
          : []
      return {
        ...state,
        patientDetails: {
          ...lastPatientDetails,
          configs: [
            ...lastPatientConfigs.filter(
              conf => conf.patient_config_id !== action.result.patient_config_id
            ),
            { ...action.result }
          ]
        }
      }
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_DUE_READ_ALL':
      // Note this is "read all" per perscriptions, which really means read one (injection due). Therefor
      // we need to sort through any existing injectionDues stored and only replace the updated one.
      if (
        lastStandardInjectionWindow != null &&
        lastStandardInjectionWindow.injectionsDue != null
      ) {
        newDataStandardInjection =
          lastStandardInjectionWindow.injectionsDue.map(injectionDue => {
            if (
              injectionDue.prescription_id === action.result.prescription_id
            ) {
              return action.result
            } else {
              return injectionDue
            }
          })
      }
      return {
        ...state,
        standardInjectionWindow:
          lastStandardInjectionWindow != null
            ? {
                ...lastStandardInjectionWindow,
                injectionsDue: newDataStandardInjection
              }
            : null
      }
    case 'STORE_PATIENT_INJECTION_ADJUST_READ':
    case 'STORE_PATIENT_INJECTION_ADJUST_READ_ALL':
    case 'STORE_PATIENT_INJECTION_ADJUST_SEARCH':
    case 'STORE_PATIENT_INJECTION_ADJUST_UPDATE':
    case 'STORE_PATIENT_INJECTION_ADJUST_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'injection_adjust_id',
          ['injAdjustWindow'],
          'adjustments'
        )
      }
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_READ':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_READ_ALL':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_SEARCH':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_CREATE':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_UPDATE':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_ADJUST_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'injection_adjust_id',
          ['injAdjustWindow'],
          'adjustments'
        )
      }
    case 'STORE_PATIENT_PURCHASE_ORDER_READ':
    case 'STORE_PATIENT_PURCHASE_ORDER_READ_ALL':
    case 'STORE_PATIENT_PURCHASE_ORDER_CREATE':
    case 'STORE_PATIENT_PURCHASE_ORDER_UPDATE':
    case 'STORE_PATIENT_PURCHASE_ORDER_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'purchase_order_id',
          ['purchaseOrderWindow'],
          'purchaseOrders'
        )
      }
    case 'STORE_PATIENT_TREATMENT_SET_READ':
    case 'STORE_PATIENT_TREATMENT_SET_READ_ALL':
    case 'STORE_PATIENT_TREATMENT_SET_SEARCH':
    case 'STORE_PATIENT_TREATMENT_SET_UPDATE':
    case 'STORE_PATIENT_TREATMENT_SET_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'treatment_set_id',
          ['orderEntryWindow'],
          'treatmentSets'
        )
      }
    case 'STORE_PATIENT_PRESCRIPTION_READ':
    case 'STORE_PATIENT_PRESCRIPTION_READ_ALL':
    case 'STORE_PATIENT_PRESCRIPTION_SEARCH':
    case 'STORE_PATIENT_PRESCRIPTION_UPDATE':
    case 'STORE_PATIENT_PRESCRIPTION_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'prescription_id',
          [
            'standardInjectionWindow',
            'nonXISInjectionsWindow',
            'prescriptionWindow',
            'orderEntryWindow',
            'injAdjustWindow',
            'patientDetails'
          ],
          'prescriptions'
        )
      }
    case 'STORE_PATIENT_ENCOUNTER_READ':
    case 'STORE_PATIENT_ENCOUNTER_READ_Search':
    case 'STORE_PATIENT_ENCOUNTER_READ_ALL':
    case 'STORE_PATIENT_ENCOUNTER_CREATE':
    case 'STORE_PATIENT_ENCOUNTER_UPDATE':
    case 'STORE_PATIENT_ENCOUNTER_DELETE':
      const encounter = Array.isArray(action.result)
        ? action.result[0]
        : action.result
      return {
        ...state,
        encounter: encounter || { state: 'logged_out' }
      }
    case 'STORE_PATIENT_INJECTION_CREATE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'injection_id',
          ['injectionWindow', 'immunotherapySummaryWindow'],
          'injections'
        )
      }
    // if its not an array, we will fall through to the block
    // below
    case 'STORE_PATIENT_INJECTION_READ':
    case 'STORE_PATIENT_INJECTION_READ_ALL':
    case 'STORE_PATIENT_INJECTION_READ_ALL_PARTIAL':
    case 'STORE_PATIENT_INJECTION_SEARCH':
    case 'STORE_PATIENT_INJECTION_SEARCH_PARTIAL':
    case 'STORE_PATIENT_INJECTION_UPDATE':
    case 'STORE_PATIENT_INJECTION_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'injection_id',
          [
            'injectionWindow',
            'injectionListWindow',
            'immunotherapySummaryWindow'
          ],
          'injections'
        )
      }
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_PLAN_READ':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_PLAN_READ_ALL':
    case 'STORE_PATIENT_PRESCRIPTION_INJECTION_PLAN_SEARCH':
      // this can use windowCrud because since read doesn't end in id
      // it technically returns and array which gets confused with read_all
      injectionGraphWindow = { ...state.injectionGraphWindow }
      injectionGraphCharts = injectionGraphWindow.charts || []
      action.result.forEach(chartResult => {
        injectionGraphCharts = injectionGraphCharts.filter(chart => {
          // remove the old version of this plan if found
          return chart.prescription_id !== chartResult.prescription_id
        })
        injectionGraphCharts.push(chartResult)
      })
      return {
        ...state,
        injectionGraphWindow: {
          ...injectionGraphWindow,
          charts: [...injectionGraphCharts]
        }
      }
    case 'STORE_PATIENT_INJECTION_PLAN_READ':
    case 'STORE_PATIENT_INJECTION_PLAN_READ_ALL':
    case 'STORE_PATIENT_INJECTION_PLAN_SEARCH':
      // this can use windowCrud because since read doesn't end in id
      // it technically returns and array which gets confused with read_all
      injectionGraphWindow = { ...state.injectionGraphWindow }
      injectionGraphCharts = injectionGraphWindow.charts || []
      action.result.forEach(chartResult => {
        injectionGraphCharts = injectionGraphCharts.filter(chart => {
          // remove the old version of this plan if found
          return chart.prescription_id !== chartResult.prescription_id
        })
        injectionGraphCharts.push(chartResult)
      })
      return {
        ...state,
        injectionGraphWindow: {
          ...injectionGraphWindow,
          charts: [...injectionGraphCharts]
        }
      }
    case 'STORE_PATIENT_SKINTEST_READ':
    case 'STORE_PATIENT_SKINTEST_READ_ALL':
    case 'STORE_PATIENT_SKINTEST_SEARCH':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'skintest_id',
          ['skintestWindow', 'orderEntryWindow'],
          'skintests'
        )
      }
    case 'STORE_CONFIG_READ':
    case 'STORE_CONFIG_READ_ALL':
    case 'STORE_CONFIG_SEARCH':
    case 'STORE_CONFIG_CREATE':
    case 'STORE_CONFIG_UPDATE':
      // create a new state object
      if (Array.isArray(action.result)) {
        // if its an array
        // for each returned config item, set the key in the
        // state object to the new value
        newData = { ...state }
        action.result.map(config => {
          switch (config.name.toUpperCase()) {
            case 'BOX1':
            case 'BOX2':
            case 'BOX3':
              newData = {
                ...newData
              }
              break
            case 'REACTION_NAMES':
              newData = {
                ...newData,
                injectionWindow:
                  lastInjectionWindow != null
                    ? { ...lastInjectionWindow, reactionNames: config.value }
                    : null
              }
              break
            default:
              break
          }
        })
        return newData
      } else {
        // if not an array, then its a single object
        // doing nothing
        return state
      }
    case 'STORE_EXTRACT_READ':
    case 'STORE_EXTRACT_READ_ALL':
    case 'STORE_EXTRACT_SEARCH':
    case 'STORE_EXTRACT_UPDATE':
    case 'STORE_EXTRACT_DELETE':
      return {
        ...state,
        ...handleWindowCRUD(action, state, 'extract_id', [], 'extracts')
      }
    case 'STORE_EXTRACT/FOR_TREATMENT_READ':
    case 'STORE_EXTRACT/FOR_TREATMENT_READ_ALL':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'extract_id',
          ['orderEntryWindow', 'vialMixingWindow'],
          'for_treatment'
        )
      }
    case 'STORE_PRESCRIPTION_PANEL_READ_ALL':
      return {
        ...state,
        ...handleWindowCRUD(
          action,
          state,
          'prescription_panel_id',
          ['orderEntryWindow'],
          'prescription_panel'
        )
      }
    default:
      return state
  }
}

export default patientDisplayReducer

const handleWindowCRUD = (
  action,
  state,
  idName,
  windows = [],
  property = ''
) => {
  // Note, although this function accepts state, it does not modify it,
  // only returns what should be merged into state
  const newWindows = {}
  windows.forEach(window => {
    let lastWindow = state[window] != null ? { ...state[window] } : null
    if (window === 'patientDetails' && lastWindow == null) {
      // this is a special case, patientDetails should always be listening for data
      // whenever we are on the patient screen
      lastWindow = {}
    }
    const newWindowData = lastWindow != null ? { ...lastWindow } : null
    if (lastWindow != null) {
      // if the window hasn't been initialized, we shouldn't change it.
      const lastWindowProperty = lastWindow[property] || []
      newWindowData[property] = handleCRUD(action, lastWindowProperty, idName)
    }
    newWindows[window] = lastWindow != null ? { ...newWindowData } : null
  })
  return newWindows
}
